import { defineStore } from "pinia";
import { ref } from "vue";

export const useHomeStore = defineStore("useHomeStore", () => {
	const daysToLookBack = ref(30);

	return {
		daysToLookBack,
	};
});
